import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { Template, RuleDTO as Rule, BLOCK_END_TYPE, FACTOR_EFFECTIVE_TYPE } from "@signature-it/ngx-generic/models";
import {DecodeBase64Pipe} from '@signature-it/ngx-generic/pipes';
declare let _: any;

@Injectable({
	providedIn: 'root'
})
export class CngPriceService {
	protected cngPricingUrl = `${this.restUrlsConf.appURL}/public/cng/pricing`;
	decodeBase64Pipe: any = new DecodeBase64Pipe();

	constructor(protected http: HttpClient,
				protected restUrlsConf: RestUrlsConfig) {
	}
	
	getPrice(pricingTemplateVars, productId = null): Observable<any> {
		let data = {};
		data['templatesVar'] = pricingTemplateVars;
		if(productId) {
			data['productId'] = productId;
		}
		return this.http.post(this.cngPricingUrl, JSON.stringify(data))
			.pipe(tap((res: HttpResponse<any>) => res, (error: any) => throwError(error)));
	}

	getAndCalcPrice(pricingTemplateVars, product): Observable<Template[]> {
		return this.getPrice(pricingTemplateVars)
			.pipe(map((data: any) => {
				const pricingTemplates = Template.createFromArray(data);
				_.forEach(pricingTemplates, (t) => {
					t = this.run(t, product);
				});
				return pricingTemplates;
			}), catchError( (error: any) => throwError(error)));
	}

	calcPrice(pricingTemplates: Template[], product): Template[] {
		_.forEach(pricingTemplates, (t) => {
			t = this.run(t, product);
		});
		return pricingTemplates;
	}

	run(template: Template, product: any) {
		_.forEach(template.blocks, (block) => {
			block.status = this.getStatus(block.rules, product);
			if(block.status) {
				if(block.startFromZero){
					template.price = 0;
				}
				if(block.linkedTemplate){
					block.linkedTemplate = this.run(block.linkedTemplate, product);
					block.isPoa = block.linkedTemplate.isPoa;
					block.additionPrice += block.linkedTemplate.price;
					template.price += block.linkedTemplate.price;
					product['updated_price'] = template.price;
				} else {
					block.status = false;
					_.forEach(block.factors, (factor) => {
						factor.status = this.getStatus(factor.rules, product);
						if (factor.status) {
							block.status = true;
							if (template.isPoa || (block.status && block.endType == BLOCK_END_TYPE.single)) {
								return;
							}
							factor.isIncludedInPrice = true;
							factor.additionPrice = this.getFactorAdditionPrice(template, factor, product);
							block.additionPrice += factor.additionPrice;
							template.price += factor.additionPrice;
							factor.updatedPrice = template.price;
							product['updated_price'] = template.price;
						}
					});
				}
			}
			if(template.isPoa || this.isBlockPoa(block)){
				template.isPoa = true;
				block.isPoa = true;
			} else {
				block.updatedPrice = template.price;
			}
			if(block.additionPriceVar){
				product[block.additionPriceVar] = block.additionPrice;
			}
			if(block.priceVar){
				product[block.priceVar] = block.updatedPrice;
			}
		});
		template.price = Number.parseFloat(template.price.toFixed(template.priceDecimalPoints));
		return template;
	}

	getStatus(rules, product){
		if(rules.length > 0) {
			return _.every(rules, (rule: Rule) => {
				const hasAllFields = rule.preJS ? this.testValidation(rule.preJS, product): rule.fields.every(f => _.isArray(product[f]) && product[f].length || !_.isArray(product[f]) && product[f] || product[f] === '0' || product[f] === 0 ? true: false);
				if (hasAllFields) {
					let test = this.testValidation(rule, product);
					return test;
				}
				return false;
			});
		} else {
			return  true;
		}
	}

	testValidation(rule: Rule, product) {
		try {
			let calc = this.evalCalcFields(rule.calcFields, product);
			return new Function(
				"ans = " + JSON.stringify(product),
				"product = " + JSON.stringify(product),
				"calc = " + JSON.stringify(calc),
				"return " + rule.ruleJS)();
		}
		catch (err) {
			console.log(`${err.message} --- RULE: ${JSON.stringify(rule)} PRODUCT: ${JSON.stringify(product)}`);
			return false;
		}
	}

	getFactorAdditionPrice(template, factor, product){
		let calc;
		switch (factor.effectiveType) {
			case FACTOR_EFFECTIVE_TYPE.fix:
				return factor.factorVal;
				break;
			case FACTOR_EFFECTIVE_TYPE.percentage:
				return template.price * factor.factorVal;
				break;
			case FACTOR_EFFECTIVE_TYPE.calc:
				calc = this.evalCalcFields(factor.calcFields, product);
				return calc[Object.keys(calc)[Object.keys(calc).length-1]];
				break;
			case FACTOR_EFFECTIVE_TYPE.calc_multiply:
				calc = this.evalCalcFields(factor.calcFields, product);
				let multiply = calc[Object.keys(calc)[Object.keys(calc).length-1]];
				return template.price * multiply;
				break;
			case FACTOR_EFFECTIVE_TYPE.var:
				if(factor.factorValVar){
					return this.evalVar(factor.factorValVar, product);
				}
				break;
		}
	}

	isBlockPoa(block){
		return (block.mandatory && !block.status);
	}

	evalCalcFields(calc, product) {
		try {
			const self = this;
			let calcFields = {};
			Object.keys(calc).map(function(key) {
				let c = '(function() {' + self.decode(calc[key]) + '})()';
				calcFields[key] = new Function(
					"ans= " + JSON.stringify(product),
					"product= " + JSON.stringify(product),
					"calc=" + JSON.stringify(calcFields),
					"return " + c)();
			});
			return calcFields;
		} catch (err) {
			console.log(`${err.message} PRODUCT: ${JSON.stringify(product)}`);
			return {};
		}
	}
	decode(value) {
		return this.decodeBase64Pipe.decode(value) || value;
	}

	evalVar(variable, product) {
		try {
			return new Function(
				"ans= " + JSON.stringify(product),
				"product= " + JSON.stringify(product),
				"return ans." + variable)();
		} catch (err) {
			console.log(`${err.message} PRODUCT: ${JSON.stringify(product)} VAR: variable`);
			return {};
		}
	}
}
